















import { Component, Vue, Prop, Provide, Emit, Watch } from 'vue-property-decorator'
import { getUrlParams } from '@/utils/urlUtils'

@Component
export default class TipModal extends Vue {
  private visible = false
  private data: any = {}

  private get tipInfo() {
    return this.$store.state.tipModal
  }
  @Watch('tipInfo', { deep: true })
  onTipChange(val, old) {
    let title: any = ''
    let content: any = ''
    if (!val) return
    // if (val.status === old.status) return
    let urlParams: any = getUrlParams('?' + val.error)

    if (urlParams && urlParams.text) {
      this.visible = val.status
      this.data = urlParams
    } else {
      // this.$message.warning(val.error)
    }
  }
  public onCancel() {
    let that = this
    this.visible = false
    setTimeout(() => {
      that.$store.commit('SET_TIPMODAL', {
        status: false,
        error: ''
      })
    }, 500)
  }
}
